import React, { Component } from 'react';
import classNames from 'classnames';
import Lottie from 'react-lottie';
import animationData from './downloadicon.json';
import { API_URL } from '../../config';
import Takeover from '../takeover';
import SpinnerDots from '../spinner/dots';
import './export-raw.scss';

class ExportRaw extends Component {
    
    state = {
        isOpen: false,
        isLoading: true,
        isDownloading: false,
        isExporting: false,
        periods:[],
        fromYear: '',
        toYear: ''
    };

    toggleTakeover() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    async fetchExportablePeriods() {
        const res = await this.props.fetch(API_URL(`/rawdata/branches/${this.props.branchId}/periodyears`)); 
        if (!res.ok) {
            //handle 404
        }
        return await res.json();
    }

    async componentDidUpdate(prevProps, prevState) {
        if  (this.state.isOpen && prevState.isOpen !== this.state.isOpen) {
            this.setState({
                isLoading: true
            });

            const periods = await this.fetchExportablePeriods();
            const fromYear = this.fromYear(periods);
            const toYear = this.toYear(periods);
            this.setState({
                isLoading: false,
                periods,
                fromYear,
                toYear
            });
        }
    }

    fromYear(periods) {
        if (periods.length-3 > -1) {
            return periods[periods.length-3];
        }

        if (periods.length-2 > -1) {
            return periods[periods.length-2];
        }
        
        return periods[0];
    }

    toYear(periods) {
        return periods[periods.length-1];
    }

    async download() {
        this.setState({
            isDownloading: true,
            isExporting: true
        });
        
        const res = await this.props.fetch(API_URL(`/rawdata/companies/${this.props.companyId}/branches/${this.props.branchId}/fromyear/${this.state.fromYear}/toyear/${this.state.toYear}`)); 
        if (!res.ok) {
            //handle 404
        }

        const blob = await res.blob();
        const href = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.download = `${this.props.name}_${this.state.fromYear}-${this.state.toYear}.xlsx`;
        a.href = href;
        a.click();
        a.href = '';
        this.setState({
            isDownloading: false,
        });

        setTimeout(() => {
            this.setState({
                isExporting: false
            });
        }, 4000);
    }

    render() {

        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice"
            }
        };


        return (
            <>
                <button className="statstics-list__item-link-btn" onClick={() => this.toggleTakeover(!this.state.isOpen)}>Exportera rådata</button>
                <Takeover isOpen={this.state.isOpen} toggleTakeover={() => this.toggleTakeover()} heading={'Exportera rådata'}>
                    <div className={classNames({
                        'export-raw': true,
                        'export-raw--is-loading': this.state.isLoading,
                        'export-raw--downloading': this.state.isDownloading,
                        'export-raw--exporting': this.state.isExporting,
                        'export-raw--is-finished': this.state.isExporting && !this.state.isDownloading
                    })}>
                        <div className="export-raw__content">
                            <label className="export-raw__select-lbl">
                                <select className="export-raw__select" value={this.state.fromYear} onChange={(e) => this.setState({
                                    fromYear: e.target.value
                                })}>
                                    {this.state.periods.map((year, i) => {
                                        return (
                                            <option key={`from${i}`} value={year}>{year}</option>
                                        );
                                    })}
                                </select>
                            </label>
                            <label className="export-raw__select-lbl">
                                <select className="export-raw__select" value={this.state.toYear} onChange={(e) => this.setState({
                                    toYear: e.target.value
                                })}>
                                    {this.state.periods.map((year, i) => {
                                        return (
                                            <option key={`to${i}`} value={year}>{year}</option>
                                        );
                                    })}
                                </select>
                            </label> 
                            <button className="form__button export-raw__download" type="button" onClick={() => this.download()}>
                                <div className="export-raw__download-icon">
                                    <Lottie options={defaultOptions} 
                                        height={30}
                                        width={30} />
                                </div>
                                <span>{this.state.isExporting ? (this.state.isDownloading ? 'Exporterar' : 'Klar!') : 'Ladda ner rådata'}</span>
                            </button>
                            <button className="export-raw__close" type="button" onClick={() => this.toggleTakeover()}>Avbryt</button>
                        </div>
                        <SpinnerDots />
                    </div>
                </Takeover>
            </>
        );    
    }
};

export default ExportRaw;